export const itemsActions = [
  {
    key: 'edit',
    label: 'Edit'
  },
  {
    key: 'archive',
    label: 'Archive'
  },
  {
    key: 're-activate',
    label: 'Re-activate'
  }
]
export const editAction = [
  {
    key: 'edit',
    label: 'Edit'
  }
]
